// 全局补丁：避免 ResizeObserver 在某些 UI 浮层（如下拉、弹层定位测量）下触发
// “ResizeObserver loop limit exceeded/undelivered notifications” 报错
// 思路：延迟回调到下一帧执行，并吞掉该类已知误报，防止开发环境的红色错误遮罩

/* eslint-disable @typescript-eslint/no-explicit-any */
export {};

(() => {
  if (typeof window === 'undefined') return;
  const OriginalResizeObserver = (window as any).ResizeObserver as
    | (new (callback: ResizeObserverCallback) => ResizeObserver)
    | undefined;
  if (!OriginalResizeObserver) return;

  class PatchedResizeObserver implements ResizeObserver {
    private readonly inner: ResizeObserver;

    constructor(callback: ResizeObserverCallback) {
      const safeCallback: ResizeObserverCallback = (entries, observer) => {
        // 将回调延迟到下一帧，避免在同一帧内反复写-读触发循环
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e: any) {
            const msg = String(e?.message || '').toLowerCase();
            if (
              msg.includes('resizeobserver loop limit exceeded') ||
              msg.includes('resizeobserver loop completed with undelivered notifications')
            ) {
              // 吞掉已知 ResizeObserver 误报
              return;
            }
            // 其他错误继续抛出
            throw e;
          }
        });
      };
      // @ts-ignore - 使用原生构造
      this.inner = new OriginalResizeObserver(safeCallback);
    }

    observe: ResizeObserver['observe'] = (target: Element, options?: ResizeObserverOptions) =>
      this.inner.observe(target, options);

    unobserve: ResizeObserver['unobserve'] = (target: Element) => this.inner.unobserve(target);

    disconnect: ResizeObserver['disconnect'] = () => this.inner.disconnect();
  }

  // 替换全局 ResizeObserver
  (window as any).ResizeObserver = PatchedResizeObserver as any;
})();
